import { Link, Outlet, useNavigate } from "react-router-dom";
import { OffcanvasNavigation } from "../components/offcanvasNavigation";
import { Button, Col, Container, Image, Row, Toast, ToastContainer } from "react-bootstrap";
import { Footer } from "../components/footer";
import { useState } from "react";
import mainLogo from "../assets/logo/logo-white.png";
import { Icon0Circle } from "react-bootstrap-icons";

export const LoginRoot = () => {
    const navigate = useNavigate();
    const [showToast, setShowToast] = useState({
        toastStatus: false,
        toastMessage: "Default Toast",
        toastAppearance: "success",
    });

    return (
        <>
            <Container fluid>
                <ToastContainer className="p-3 toast-container">
                    <Toast
                        onClose={() => setShowToast({ toastStatus: false })}
                        show={showToast.toastStatus}
                        delay={6000}
                        autohide
                        bg={showToast.toastAppearance}
                        animation={true}
                    >
                        <Toast.Body>{showToast.toastMessage}</Toast.Body>
                    </Toast>
                </ToastContainer>

                <Row className="p-3 border-bottom border-white d-flex align-items-center bg-dark">
                    <Col xs={2}>
                        <Image src={mainLogo} height={50} onClick={() => navigate("/")} style={{ cursor: "pointer" }} />
                    </Col>
                    <Col xs={10} className="text-end d-flex justify-content-end align-items-center">
                        <Link 
                            className="me-3 btn btn-outline-light"
                            to={'https://www.kiddiefy-academy.de/'}
                            target="_blank"
                        >
                                Zur Kiddiefy-Academy
                        </Link>
                        <OffcanvasNavigation />
                    </Col>
                </Row>

                <Row style={{ minHeight: "88vh" }}>
                    <Col className="p-0">
                        <Outlet context={[showToast, setShowToast]} />
                    </Col>
                </Row>

                <Row className="border-top border-white bg-dark" style={{ maxHeight: "100px" }}>
                    <Col className="p-3 text-center">
                        <Footer />
                    </Col>
                </Row>
            </Container>
        </>
    );
};
